// extracted by mini-css-extract-plugin
export var box = "_j-2";
export var checkboxControl = "_j-0";
export var checkboxRow = "_j-a";
export var checked = "_j-3";
export var descriptionSpacer = "_j-c";
export var disabled = "_j-4";
export var icon = "_j-8";
export var input = "_j-1";
export var labelSpacer = "_j-b";
export var large = "_j-7";
export var medium = "_j-6";
export var small = "_j-5";
export var text = "_j-9";